"use client";

import Link from "next/link";
import { useSiteStatus } from "@/components/SiteStatusGate";

export default function NavLinks() {
  const {
    payments: { enabled: paymentsEnabled },
  } = useSiteStatus();
  return (
    <div className="flex flex-row flex-wrap gap-2 xsm:gap-2 sm:gap-3 md:gap-4 lg:gap-[1.6rem] xl:gap-8">
      <Link
        href="/find-a-teacher"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerFindTeacherLink"
      >
        Find a teacher
      </Link>
      <Link
        href="/about"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerAboutLink"
      >
        About
      </Link>
      <Link
        href="/how-it-works"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerHowItWorksLink"
      >
        How it works
      </Link>
      {paymentsEnabled && (
        <Link
          href="/packages"
          className="hidden text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:block lg:text-lg xl:text-xl"
          data-testid="footerPackagesLink"
        >
          Packages
        </Link>
      )}
      <Link
        href="/become-a-teacher"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerBecomeTeacherLink"
      >
        Become a teacher
      </Link>
      <Link
        href="/help"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerHelpLink"
      >
        Help
      </Link>
      <Link
        href="/terms"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerTermsLink"
      >
        Terms
      </Link>
      <Link
        href="/policy"
        className="text-xs font-medium text-[#27335d] transition-all hover:text-gray-400 xsm:text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl"
        data-testid="footerPolicyLink"
      >
        Policy
      </Link>
    </div>
  );
}
